export let backend = 'https://new.mypicosign.com'
//export let backend = 'http://192.168.130.88:8000'
// export let backend = 'http://192.168.132.26:8000'



// WEBPACK FOOTER //
// ./src/settings.js